import styled, {css, keyframes} from "styled-components";

const sliceLineKeyframes = keyframes`
    0% {
        background-size: 100% 0%;
    }
    100% {
        background-size: 100% 100%;
    }
`;

/**
 * The formula for rotating the line.
 * (360*N)/2 (divides 360 deg to N prizes to find the degress of one slice, divide by 2 to offset half of the slice). Can be optimized to 180/N
 * The first line is tilted backwards, hence the "-" minus sign, the second is tilted forwards hence no sign, because "+" is implicit
 * Resulting formula: plus or minus 180/N
 */

export const SliceLineDefaultBox = styled.div<{animate: boolean; numberOfSlices: number; secondLine?: boolean;}>`
    position: absolute;
    height: 50%;
    width: 1%;
    filter: blur(1px);
    transform: rotate(${({secondLine}) => secondLine ? "" : "-"}${props => 180/props.numberOfSlices}deg) translateY(-50%);
    background-size: 100% 0%;
    background-image: linear-gradient(to left, transparent 0, #ffffff 40%, #ffffff 70%, transparent 100%);
    background-repeat: no-repeat;
    background-position: ${({secondLine}) => secondLine ? "100% 100%" : "0 0"};

    ${({animate, secondLine}) => animate ? css`
        animation: ${sliceLineKeyframes} 100ms ease-in forwards;
        animation-delay: ${secondLine ? "0.1s" : "0"};
    ` : null}
`;